"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _keyExtractor = require("./keyExtractor");
Object.keys(_keyExtractor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _keyExtractor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _keyExtractor[key];
    }
  });
});
